"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewModuleEditorSchema = void 0;
const baseSchema_1 = require("../baseSchema");
const baseViewSchema_1 = require("../baseSchema/baseViewSchema");
class ViewModuleEditorSchema extends baseViewSchema_1.BaseViewSchema {
    constructor({ path, productId, arrivedFrom }) {
        super({ arrivedFrom: arrivedFrom || 'X' });
        this.action = baseSchema_1.ActionsName.VIEW_CREATE_MODULE;
        this.path = path;
        this.productId = productId || 0;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            path: this.path,
            productId: this.productId
        };
    }
}
exports.ViewModuleEditorSchema = ViewModuleEditorSchema;
